const getBusinessEmail = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Contact'] && business['Company Contact'].ID) {
    return business['Company Contact']['Company Email'];
  }
  return null;
};

export default getBusinessEmail;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessEmail.js